var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.visible
    ? _c(
        "AppDialog",
        {
          attrs: {
            title: _vm.title,
            width: "730px",
            height: "390px",
            top: "8vh",
            "custom-class": "home-user-info-dialog",
          },
          on: { success: _vm.successFn },
          model: {
            value: _vm.config.visible,
            callback: function ($$v) {
              _vm.$set(_vm.config, "visible", $$v)
            },
            expression: "config.visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "div",
                { staticClass: "profile-header" },
                [
                  _c("AppAvatar", {
                    staticClass: "header-avatar",
                    attrs: {
                      name: _vm.userInfo.nickName || _vm.userInfo.userName,
                      width: "64",
                      avatar: _vm.userInfo.avatar,
                      "no-name": true,
                    },
                  }),
                  _c("div", { staticClass: "header-info" }, [
                    _c("div", [
                      _c("span", { staticClass: "header-laber" }, [
                        _vm._v("员工姓名："),
                      ]),
                      _c("span", [_vm._v(" " + _vm._s(_vm.data.nickName))]),
                    ]),
                    _c("div", [
                      _c("span", { staticClass: "header-laber" }, [
                        _vm._v("手机号码："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.data.phoneNumber))]),
                    ]),
                    _c("div", [
                      _c("span", { staticClass: "header-laber" }, [
                        _vm._v("所在部门："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.data.deptName))]),
                    ]),
                    _c("div", { staticClass: "text_hidden_3" }, [
                      _c("span", { staticClass: "header-laber" }, [
                        _vm._v("角色组："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.data.roleNames))]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("el-divider"),
              _c(
                "div",
                { staticClass: "bind-section" },
                [
                  _vm.config.visible && _vm.data.userId
                    ? _c(
                        "CorpWxAccountBindTabs",
                        {
                          attrs: {
                            "user-id": _vm.data.userId,
                            phone: _vm.data.phoneNumber || "",
                          },
                          on: { change: _vm.getBindList },
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm._v(" 第三方账号绑定："),
                              _c(
                                "el-button",
                                {
                                  staticClass: "m-l-10",
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-plus",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openBindTypeDialog()
                                    },
                                  },
                                },
                                [_vm._v("新增")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "thirdAccounts-container" },
                            _vm._l(_vm.bindList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "third-account-card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("span", { staticClass: "tag-wechat" }, [
                                      _vm._v("企业微信"),
                                    ]),
                                    _c("div", { staticClass: "actions" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "action-btn bind-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openBindTypeDialog(
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("换绑")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "action-btn unbind-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.delThirdAccounts(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("解绑")]
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "card-content" }, [
                                    _c(
                                      "div",
                                      { staticClass: "user-info" },
                                      [
                                        _c(
                                          "el-image",
                                          {
                                            staticClass: "avatar",
                                            attrs: {
                                              src:
                                                typeof item === "object"
                                                  ? item.avatar ||
                                                    item.headImageUrl ||
                                                    item.bizWechatAvatar ||
                                                    ""
                                                  : "",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "error" }, [
                                              _c("img", {
                                                staticClass: "avatar",
                                                attrs: {
                                                  src: require("@/assets/image/imgloadError.png"),
                                                },
                                              }),
                                            ]),
                                          ],
                                          2
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "name-info" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "user-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    typeof item === "string"
                                                      ? item
                                                      : item.nickName ||
                                                          item.userName ||
                                                          item.name ||
                                                          item.employeeName ||
                                                          item.bizWechatName ||
                                                          "未命名"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "corp-name" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            typeof item === "object"
                                              ? item.corpName ||
                                                  item.companyName ||
                                                  item.customerName ||
                                                  "已绑定企业微信"
                                              : "已绑定企业微信"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.isRebind ? "选择换绑方式" : "选择绑定方式",
                visible: _vm.bindTypeVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.bindTypeVisible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "bind-type-list" }, [
                _c(
                  "div",
                  {
                    staticClass: "bind-type-item",
                    on: { click: _vm.chooseScanBind },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-full-screen bind-type-icon",
                    }),
                    _c("div", { staticClass: "bind-type-text" }, [
                      _c("div", { staticClass: "bind-type-name" }, [
                        _vm._v("扫码绑定"),
                      ]),
                      _c("div", { staticClass: "bind-type-desc" }, [
                        _vm._v("使用企业微信扫码完成绑定"),
                      ]),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-arrow-right bind-type-arrow",
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "bind-type-item",
                    on: { click: _vm.choosePhoneBind },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-mobile-phone bind-type-icon",
                    }),
                    _c("div", { staticClass: "bind-type-text" }, [
                      _c("div", { staticClass: "bind-type-name" }, [
                        _vm._v("手机号绑定"),
                      ]),
                      _c("div", { staticClass: "bind-type-desc" }, [
                        _vm._v("通过手机号绑定企业微信"),
                      ]),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-arrow-right bind-type-arrow",
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.isRebind ? "手机号换绑" : "手机号绑定",
                visible: _vm.phoneBindVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.phoneBindVisible = $event
                },
                close: _vm.closePhoneBindDialog,
              },
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "10px 0" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        maxlength: "11",
                        placeholder: "请输入手机号",
                        clearable: "",
                      },
                      model: {
                        value: _vm.phoneInput,
                        callback: function ($$v) {
                          _vm.phoneInput =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "phoneInput",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("手机号")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.closePhoneBindDialog },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.phoneBindLoading,
                      },
                      on: { click: _vm.submitPhoneBind },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.isRebind ? "企业微信换绑" : "企业微信绑定",
                visible: _vm.qrCodeVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.qrCodeVisible = $event
                },
                close: _vm.closeQrCodeDialog,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.qrCodeLoading,
                      expression: "qrCodeLoading",
                    },
                  ],
                  staticStyle: { "text-align": "center", padding: "30px 0" },
                },
                [
                  !_vm.bindSuccess
                    ? [
                        _c("i", {
                          staticClass: "el-icon-link",
                          staticStyle: {
                            "font-size": "48px",
                            color: "#409EFF",
                            "margin-bottom": "16px",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-bottom": "24px",
                              color: "#666",
                              "font-size": "14px",
                              "line-height": "1.5",
                            },
                          },
                          [
                            _vm._v(
                              " 请点击下方按钮在新窗口中打开企业微信页面进行扫码" +
                                _vm._s(_vm.isRebind ? "换绑" : "绑定") +
                                "。 "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.openWechatAuth },
                              },
                              [
                                _vm._v(
                                  "前往扫码" +
                                    _vm._s(_vm.isRebind ? "换绑" : "绑定")
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              { on: { click: _vm.closeQrCodeDialog } },
                              [
                                _vm._v(
                                  "我已完成" +
                                    _vm._s(_vm.isRebind ? "换绑" : "绑定")
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c("i", {
                          staticClass: "el-icon-success",
                          staticStyle: {
                            "font-size": "64px",
                            color: "#67C23A",
                            "margin-bottom": "16px",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#67C23A",
                              "font-size": "18px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.bindSuccessText) + " ")]
                        ),
                      ],
                ],
                2
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }